import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-00715c4b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "PrivacyStatement" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createTextVNode(" By registering, you agree to our "),
    _createElementVNode("a", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.trackPrivacyStatementClick && _ctx.trackPrivacyStatementClick(...args))),
      class: "Link PrivacyStatementLink",
      href: "https://www.studyportals.com/about-us/privacy-2/",
      target: "_blank"
    }, " Privacy Statement "),
    _createTextVNode(" and "),
    _createElementVNode("a", {
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.trackTermsAndConditionsClick && _ctx.trackTermsAndConditionsClick(...args))),
      class: "Link TermsAndConditionsLink",
      href: "https://www.studyportals.com/about-us/terms/",
      target: "_blank"
    }, " Terms and Conditions "),
    _createTextVNode(". ")
  ]))
}